import React from 'react';
import { getColorSchemes } from '../utils/colorSchemes';
import './ColorSchemeSelector.css';

export const ColorSchemeSelector = ({ currentScheme, onSelectScheme, onClose }) => {
  const schemes = getColorSchemes();

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="color-scheme-selector" onClick={(e) => e.stopPropagation()}>
        <div className="color-scheme-header">
          <h2>Choose Color Scheme</h2>
          <button className="close-btn" onClick={onClose}>✕</button>
        </div>

        <div className="color-scheme-content">
          <p className="color-scheme-description">
            Personalize your learning experience with a color scheme that suits your style
          </p>

          <div className="color-scheme-grid">
            {schemes.map((scheme) => (
              <button
                key={scheme.id}
                className={`color-scheme-option ${currentScheme === scheme.id ? 'selected' : ''}`}
                onClick={() => {
                  onSelectScheme(scheme.id);
                  onClose();
                }}
              >
                <span className="color-scheme-emoji">{scheme.emoji}</span>
                <span className="color-scheme-name">{scheme.name}</span>
                {currentScheme === scheme.id && (
                  <span className="color-scheme-check">✓</span>
                )}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
